import queryString from 'query-string'
import { LifeCycleStatus } from 'shared/constants/signingTypes'

export function getColor(type: string, data: any[]) {
	const color1 = '#c87d5a' // Bronze red
	const color2 = '#eea87e' // Bronze light
	let list: any[] = []
	data.forEach((item: any) => {
		list.push(item.loanType)
	})
	let item = list.indexOf(type)
	return item % 2 === 0 ? color1 : color2
}

export function setFullMobileViewHeight() {
	let vh = window.innerHeight * 0.01
	document.documentElement.style.setProperty('--vh', `${vh}px`)
	window.addEventListener('resize', () => {
		let vh = window.innerHeight * 0.01
		document.documentElement.style.setProperty('--vh', `${vh}px`)
	})
}

export function getAccessTokenParam() {
	const props = queryString.parse(window.location.search) as {
		access_token: string
	}

	console.info('url_access_token', props && props.access_token)
	return props ? props.access_token : ''
}

export function normalizeUrl(url: string) {
	return url.substr(-1) === '/' ? url.slice(0, -1) : url
}

export function stringifyBooleanAsUi(bool: boolean) {
	if (bool) {
		return 'Yes'
	} else {
		return 'No'
	}
}

export function addZeroToDate(n: number) {
	return n < 10 ? '0' + n : '' + n
}

// A test phone number for EE: 37200000766

//ApplicationPage helper
export const checkLifeCycleStatus = (status: LifeCycleStatus | undefined) => {
	switch (status) {
		case LifeCycleStatus.Canceled:
		case LifeCycleStatus.Denied:
		case LifeCycleStatus.Disbursed:
		case LifeCycleStatus.TimedOut:
		case LifeCycleStatus.Duplicated:
			return true
		default:
			return false
	}
}
